module.exports = "https://web-assets.ifttt.com/packs/media/partners/down_arrow-b8a9092d.svg";